import { supabase } from '../../lib/supabase'
import { resetBranding } from '../../lib/branding'

export default function SuspendedPage() {
  return (
    <div className="min-h-screen bg-paper flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="text-6xl mb-6">⚠️</div>
        <h1 className="text-2xl font-bold text-ink mb-3">Acesso suspenso</h1>
        <p className="text-ink-muted mb-2">
          Sua assinatura está suspensa ou vencida.
        </p>
        <p className="text-ink-muted mb-8">
          Entre em contato para regularizar e reativar o acesso.
        </p>
        <a
          href="https://wa.me/5511984016741?text=Olá,%20preciso%20reativar%20minha%20assinatura%20BX%20Solutions"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-6 py-3 bg-brand-600 hover:bg-brand-700 text-white font-semibold rounded-lg transition-colors mb-4"
        >
          Falar no WhatsApp
        </a>
        <div className="mt-6">
          <button
            onClick={() => { resetBranding(); supabase.auth.signOut() }}
            className="text-sm text-ink-faint hover:text-ink-muted transition-colors"
          >
            Sair da conta
          </button>
        </div>
      </div>
    </div>
  )
}
